export class Algorithm {

    public description: String = "";
    public algorithm: String = "";
}